export default function BackIcon() {
  return (
    <svg
      width="42"
      height="42"
      viewBox="0 0 42 42"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect x="0.5" y="0.5" width="41" height="41" rx="20.5" fill="white" />
      <rect x="0.5" y="0.5" width="41" height="41" rx="20.5" stroke="#D7DFE9" />
      <path
        d="M27.1875 21H14.8125M14.8125 21L19.875 15.9375M14.8125 21L19.875 26.0625"
        stroke="#455468"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
